import { createActionHelpers } from 'vuex-loading';
import Big from 'big.js';
import localForage from 'localforage';
import Auth from '@js/plugins/auth';

const { startLoading, endLoading } = createActionHelpers({
    moduleName: 'loading',
});

const store = localForage.createInstance({
    storeName: `till_closure_${Auth.user().id}`,
    namespaced: true,
});

const Laroute = require('../../laroute');
let localTypeDate = localStorage.getItem('timezones');

store.getItem('filters').then(filters => {
    if (filters) {
        state.filters = filters;
    }
});

const state = {
    searchMeta: null,
    filters: [],
    day_operation: 0,
    till_id: 0,
    till_time_close: null,
    tillClosure: {
        id: null,
        name: null,
        cardList: [],
        cardSummary: [],
    },
};

const mutations = {
    setTypeDateFilter(state, typeDate) {
        state.typeDate = typeDate;
    },

    setDayOperation(state, day_operation) {
        state.day_operation = day_operation;
    },

    setTillId(state, till_id) {
        state.till_id = till_id;
    },
    setTillTimeClose(state, till_time_close) {
        state.till_time_close = till_time_close;
    },

    setTillClosure(state, tillClosure) {
        state.tillClosure = tillClosure;
    },

    setSearchMeta(state, meta) {
        state.searchMeta = meta;
    },

    async setFilters(state, filters) {
        state.filters = filters;
        await store.setItem('filters', filters);
    },
};

const getters = {
    day_operation() {
        return state.day_operation;
    },

    till_id() {
        return state.till_id;
    },
    till_time_close() {
        return state.till_time_close;
    },

    hasTillClosure(state) {
        return state.tillClosure.id !== null;
    },

    tillClosure(state) {
        return state.tillClosure;
    },

    cardList() {
        return state.tillClosure.cardList;
    },

    cardType() {
        return state.tillClosure.cardType;
    },

    cardSummary() {
        return state.tillClosure.cardSummary;
    },

    topupSales() {
        return state.tillClosure.topupSales;
    },

    totalTopup(state, getters) {
        const totalQuantity = getters.topupSales
            .map(r => {
                return parseInt(r.total_receipt);
            })
            .reduce((a, b) => a + b, 0);

        const totalAmount = getters.topupSales
            .map(r => {
                return r.total_amount;
            })
            .reduce((a, b) => Big(a).plus(Big(b)), 0);

        return {
            total_quantity: totalQuantity,
            total_amount: Big(totalAmount).toFixed(2),
        };
    },

    totalCardList(state, getters) {
        const totalQuantity = getters.cardList
            .map(r => {
                return parseInt(r.quantity);
            })
            .reduce((a, b) => a + b, 0);

        const totalAmount = getters.cardList
            .map(r => {
                return parseFloat(r.amount_card_sales);
            })
            .reduce((a, b) => a + b, 0);

        return {
            total_quantity: totalQuantity,
            total_amount: totalAmount,
        };
    },

    totalCardType(state, getters) {
        const totalQuantity = getters.cardType
            .map(r => {
                return r.quantity;
            })
            .reduce((a, b) => Big(a).plus(Big(b)), 0);

        const totalAmount = getters.cardType
            .map(r => {
                return r.amount_card_sales;
            })
            .reduce((a, b) => Big(a).plus(Big(b)), 0);

        return {
            total_quantity: Big(totalQuantity).toString(),
            total_amount: Big(totalAmount).toFixed(2),
        };
    },

    totalCardSummary(state, getters) {
        const totalQuantity = getters.cardSummary
            .map(r => {
                return r.cardcount;
            })
            .reduce((a, b) => Big(a).plus(Big(b)), 0);

        const totalAmount = getters.cardSummary
            .map(r => {
                return r.subtotal;
            })
            .reduce((a, b) => Big(a).plus(Big(b)), 0);

        return {
            total_quantity: Big(totalQuantity).toString(),
            total_amount: Big(totalAmount).toFixed(2),
        };
    },
};

const actions = {
    getDayOperation({ commit, dispatch }, id) {
        let route = Laroute.route(
            'franchise.report.till_closure.day-operation',
            {
                id,
            },
        );

        startLoading(dispatch, 'fetch-day-operation');

        return axios
            .get(route)
            .then(res => {
                endLoading(dispatch, 'fetch-day-operation');
                commit('setDayOperation', res.data.data);
                return res;
            })
            .catch(err => {
                endLoading(dispatch, 'fetch-day-operation');
                throw err;
            });
    },

    getTillId({ commit, dispatch }, id) {
        let route = Laroute.route('franchise.report.till_closure.till-id', {
            id,
        });

        startLoading(dispatch, 'fetch-till-id');

        return axios
            .get(route)
            .then(res => {
                endLoading(dispatch, 'fetch-till-id');
                commit('setTillId', res.data.data);
                return res;
            })
            .catch(err => {
                endLoading(dispatch, 'fetch-till-id');
                throw err;
            });
    },
    getTillTimeCLose({ commit, dispatch }, id) {
        let route = Laroute.route(
            'franchise.report.till_closure.till-time-close',
            {
                id,
            },
        );

        startLoading(dispatch, 'fetch-till-time-close');

        return axios
            .get(route)
            .then(res => {
                endLoading(dispatch, 'fetch-till-time-close');
                commit('setTillTimeClose', res.data.data);
                return res;
            })
            .catch(err => {
                endLoading(dispatch, 'fetch-till-time-close');
                throw err;
            });
    },

    getCardSales({ commit, dispatch }, id) {
        let route = Laroute.route(
            'franchise.report.till_closure.showcardsale',
            {
                id,
            },
        );
        startLoading(dispatch, 'fetch-till-closure');

        return axios
            .get(route)
            .then(res => {
                endLoading(dispatch, 'fetch-till-closure');
                commit('setTillClosure', res.data);
                return res;
            })
            .catch(err => {
                endLoading(dispatch, 'fetch-till-closure');
                throw err;
            });
    },

    getCardEDCSales({ commit, dispatch }, id) {
        let route = Laroute.route(
            'franchise.report.till_closure.showcardedcsale',
            {
                id,
            },
        );
        startLoading(dispatch, 'fetch-till-closure');

        return axios
            .get(route)
            .then(res => {
                endLoading(dispatch, 'fetch-till-closure');
                commit('setTillClosure', res.data);
                return res;
            })
            .catch(err => {
                endLoading(dispatch, 'fetch-till-closure');
                throw err;
            });
    },

    getSearchMeta({ commit, dispatch }) {
        const route = Laroute.route(
            'franchise.report.till_closure.search.meta',
        );

        startLoading(dispatch, 'get-tillmeta');

        return axios
            .get(route)
            .then(res => {
                commit('setSearchMeta', res.data);
                endLoading(dispatch, 'get-tillmeta');
                return res.data;
            })
            .catch(err => {
                endLoading(dispatch, 'get-tillmeta');
                throw err;
            });
    },

    getSearchMetaIfNecessary({ commit, dispatch }) {
        if (!state.searchMeta) {
            return dispatch('getSearchMeta');
        }

        return Promise.resolve(state.searchMeta);
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
